import React from 'react';

import ClassroomCourseTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ClassroomCourseTable />
    </div>
  );
};
